import { Loader } from "lucide-react";

export default function LoaderScreen() {
  return (
    <div className="grid h-screen w-full items-center justify-center">
      <Loader className="text-action-primary h-12 w-12 animate-spin" />
    </div>
  );
}
